export default __webpack_public_path__ + "static/media/jnh4.1201226f.jpg";